// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "277eeeaa92057fcb","396": "75d2ec6cf1555fca","460": "901d09786d6b4ea1","498": "496844ef0c94815f","917": "860baa9109b4733d","985": "ac3dc9ef17fd2b5e",}[chunkId] + ".chunk.js"
}